const PUBLIC_PROFILE = 'public_profile';
const EMAIL = 'email';
const PAGES_MANAGE_METADATA = 'pages_manage_metadata';
const PAGES_READ_ENGAGEMENT = 'pages_read_engagement';
const PAGES_READ_USER_CONTENT = 'pages_read_user_content';
const PAGES_MESSAGING = 'pages_messaging';
const PAGES_SHOW_LIST = 'pages_show_list';
const ADS_READ = 'ads_read';
const ADS_MANAGEMENT = 'ads_management';
const PAGES_MANAGE_ADS = 'pages_manage_ads';
const IG_BASIC = 'instagram_basic';
const IG_MANAGE_MESSAGES = 'instagram_manage_messages';
const IG_MANAGE_COMMENTS = 'instagram_manage_comments';
const IG_MANAGE_INSIGHTS = 'instagram_manage_insights';
const BUSINESS_MANAGMENT = 'business_management';

export type PermissionDefinition = {
  permission: string;
  name: string;
  description: string;
  redirectToSignupOnClose?: boolean;
};

/* tslint:disable */
const basePermissions = {
  [PUBLIC_PROFILE]: {
    permission: PUBLIC_PROFILE,
    name: 'Public profile',
    description:
      'we use your first name and last name to create your MobileMonkey account. Your profile picture is used to personalize your user menu.',
    redirectToSignupOnClose: true,
  },
  [EMAIL]: {
    permission: EMAIL,
    name: 'Email address',
    description:
      'Your Facebook email address is used to notify you if a page becomes disconnected for some reason, and for sending product updates.',
    redirectToSignupOnClose: true,
  },
  [PAGES_MANAGE_METADATA]: {
    permission: PAGES_MANAGE_METADATA,
    name: 'Manage your Pages Activity',
    description:
      "We use this permission to receive notifications of activity on your page like Post comments, so that you can configure responses to them. As always, we'll never send anything unless you say to.",
    redirectToSignupOnClose: true,
  },
  [BUSINESS_MANAGMENT]: {
    permission: BUSINESS_MANAGMENT,
    name: 'Manage business assets',
    description:
      'We use this permission to allow you to connect pages with New Pages Experience which are managed with the Business Manager API.',
    redirectToSignupOnClose: true,
  },
  [PAGES_READ_ENGAGEMENT]: {
    permission: PAGES_READ_ENGAGEMENT,
    name: 'Read Pages Engagement',
    description:
      "We use this permission to view the content of posts on your page, so that you can configure custom auto-responders for this activity. As always, we'll never send anything unless you say to.",
    redirectToSignupOnClose: true,
  },
  [PAGES_READ_USER_CONTENT]: {
    permission: PAGES_READ_USER_CONTENT,
    name: 'Read User Content',
    description:
      "We use this permission to view the content of comments on your posts, so that you can configure custom auto-responders for this activity. As always, we'll never send anything unless you say to.",
    redirectToSignupOnClose: true,
  },
  [PAGES_MESSAGING]: {
    permission: PAGES_MESSAGING,
    name: 'Send messages from pages you manage',
    description:
      "we need this permission in order to automate your replies, which you'll be able to completely customize once you're inside.",
    redirectToSignupOnClose: true,
  },
  [PAGES_SHOW_LIST]: {
    permission: PAGES_SHOW_LIST,
    name: 'Display your pages',
    description:
      'we use the list of your Facebook pages to show you what pages you can connect to MobileMonkey.',
    redirectToSignupOnClose: false,
  },
  [ADS_READ]: {
    permission: ADS_READ,
    name: 'Facebook Ads',
    description:
      'we use this permission to display Messenger Ad performance data as well as to create and send Sponsored Messages for you using MobileMonkey content',
    redirectToSignupOnClose: false,
  },
  [PAGES_MANAGE_ADS]: {
    permission: PAGES_MANAGE_ADS,
    name: 'Manage Ads',
    description:
      "We use this permission to display Messenger Ad performance data as well as to help you create and send Sponsored Messages. As always, we'll never send anything unless you say to.",
    redirectToSignupOnClose: false,
  },
  [ADS_MANAGEMENT]: {
    permission: ADS_MANAGEMENT,
    name: 'Facebook Ads',
    description:
      'we use this permission to display Messenger Ad performance data as well as to create and send Sponsored Messages for you using MobileMonkey content',
    redirectToSignupOnClose: false,
  },
  [IG_BASIC]: {
    permission: IG_BASIC,
    name: 'Instagram Basic',
    description:
      'We use this permission to get basic metadata of an Instagram Business account profile, for example username and ID',
    redirectToSignupOnClose: false,
  },
  [IG_MANAGE_MESSAGES]: {
    permission: IG_MANAGE_MESSAGES,
    name: 'Instagram Manage Messages',
    description: '',
    redirectToSignupOnClose: false,
  },
  [IG_MANAGE_COMMENTS]: {
    permission: IG_MANAGE_COMMENTS,
    name: 'Instagram Manage Comments',
    description:
      'We use this permission to read, update and delete comments of Instagram Business accounts and read media objects, such as stories, of Instagram Business accounts.',
    redirectToSignupOnClose: false,
  },
  [IG_MANAGE_INSIGHTS]: {
    permission: IG_MANAGE_INSIGHTS,
    name: 'Instagram Manage Insights',
    description:
      'We use this permission to get metadata, data insights, story insights of an Instagram Business account.',
    redirectToSignupOnClose: false,
  },
};
/* tslint:enable */

const BASIC_PERMISSIONS = [
  basePermissions[PUBLIC_PROFILE],
  basePermissions[EMAIL],
];
const FB_GUARD_PERMISSIONS = [
  ...BASIC_PERMISSIONS,
  basePermissions[PAGES_MESSAGING],
];
const PAGE_PERMISSIONS = [
  ...BASIC_PERMISSIONS,
  basePermissions[PAGES_MANAGE_METADATA],
  basePermissions[PAGES_READ_ENGAGEMENT],
  basePermissions[PAGES_READ_USER_CONTENT],
  basePermissions[PAGES_MESSAGING],
  basePermissions[BUSINESS_MANAGMENT],
];
const SIGNUP_PERMISSIONS = [
  ...BASIC_PERMISSIONS,
  basePermissions[BUSINESS_MANAGMENT],
  basePermissions[PAGES_SHOW_LIST],
  basePermissions[ADS_READ],
  basePermissions[PAGES_MANAGE_METADATA],
  basePermissions[PAGES_READ_ENGAGEMENT],
  basePermissions[PAGES_READ_USER_CONTENT],
  basePermissions[PAGES_MANAGE_ADS],
  basePermissions[PAGES_MESSAGING],
];
const CAMPAIGN_PERMISSIONS = [...PAGE_PERMISSIONS];

const MESSENGER_ADS_PERMISSIONS = [
  basePermissions[ADS_READ],
  basePermissions[PAGES_MANAGE_ADS],
];
const AUDIENCE_ADS_PERMISSIONS = [
  basePermissions[ADS_READ],
  basePermissions[ADS_MANAGEMENT],
  basePermissions[PAGES_MANAGE_ADS],
];

const INSTAGRAM_PERMISSIONS = [
  basePermissions[PAGES_MANAGE_ADS],
  basePermissions[PAGES_MANAGE_METADATA],
  basePermissions[PAGES_READ_ENGAGEMENT],
  basePermissions[PAGES_READ_USER_CONTENT],
  basePermissions[PAGES_MESSAGING],
  basePermissions[ADS_READ],
  basePermissions[ADS_MANAGEMENT],
  basePermissions[IG_BASIC],
  basePermissions[IG_MANAGE_MESSAGES],
  basePermissions[IG_MANAGE_COMMENTS],
];

const IG_SIGNUP_PERMISSIONS = [
  ...INSTAGRAM_PERMISSIONS,
  ...BASIC_PERMISSIONS,
  basePermissions[PAGES_SHOW_LIST],
  basePermissions[BUSINESS_MANAGMENT],
];

const ALL_PERMISSIONS = [
  ...SIGNUP_PERMISSIONS,
  basePermissions[ADS_MANAGEMENT],
];

type GetArrayOfSpecificFields = <Key extends keyof PermissionDefinition>(
  field: Key,
) => (permissionsArray: PermissionDefinition[]) => PermissionDefinition[Key][];

const getArrayOfSpecificFields: GetArrayOfSpecificFields =
  field => permissionsArray =>
    permissionsArray.map(p => p[field]);

const getArrayOfPermissions = getArrayOfSpecificFields('permission');
const getArryaOfDescriptions = getArrayOfSpecificFields('description');

type RedirectToSignup = (permissionsArray: PermissionDefinition[]) => boolean;

// Current implementation of this function is relatively dumb.
// It takes into account the fact that we have either /signup route or none,
// with /signup taking priority.
// If we decide to introduce more sophisticated redirect logic, we need to improve logic here.
const redirectToSignup: RedirectToSignup = (permissionsArray = []) =>
  permissionsArray.some(p => p.redirectToSignupOnClose);

export {
  BASIC_PERMISSIONS,
  FB_GUARD_PERMISSIONS,
  PAGE_PERMISSIONS,
  CAMPAIGN_PERMISSIONS,
  SIGNUP_PERMISSIONS,
  MESSENGER_ADS_PERMISSIONS,
  AUDIENCE_ADS_PERMISSIONS,
  ALL_PERMISSIONS,
  IG_SIGNUP_PERMISSIONS,
  getArrayOfPermissions,
  getArryaOfDescriptions,
  redirectToSignup,
  INSTAGRAM_PERMISSIONS,
};
